// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".good--text[data-v-84f9eff8] {\n  color: #139E06;\n}\n.lag-text[data-v-84f9eff8] {\n  font-size: 0.625rem;\n}\n.status-wrapper[data-v-84f9eff8] {\n  position: relative;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
